import mapValues from 'lodash.mapvalues';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

/**
 * Function to get the RGB values from a HEX string
 */
function hexToRgb(hex) {
  var lowerCaseHex = hex.toLowerCase(); // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")

  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  var expandedHex = lowerCaseHex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b;
  }); // Get result.

  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(expandedHex);

  if (!result) {
    return null;
  } // Parse result


  return {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  };
}

// If those constants were to change later, this migration could potentially be doing the wrong thing.

var DEFAULT_BLOCK_TYPE = 'unstyled';
var ListBlockTypes = {
  UNORDERED_LIST_ITEM: 'unordered-list-item',
  ORDERED_LIST_ITEM: 'ordered-list-item'
};
var TEXT_ALIGN_BLOCK_DATA_KEY = 'text-align';
/**
 * Version 1:
 * Migrating from nucleus-core rich text editor raw draftjs JSON object to one that is compatible with
 * the carina-rich-text-editor.
 */

function blockMigrations(block) {
  var newData = {};
  var newType = block.type;

  switch (block.type) {
    // Text alignment
    case 'left':
      newType = DEFAULT_BLOCK_TYPE;
      newData[TEXT_ALIGN_BLOCK_DATA_KEY] = 'left';
      break;

    case 'center':
      newType = DEFAULT_BLOCK_TYPE;
      newData[TEXT_ALIGN_BLOCK_DATA_KEY] = 'center';
      break;

    case 'right':
      newType = DEFAULT_BLOCK_TYPE;
      newData[TEXT_ALIGN_BLOCK_DATA_KEY] = 'right';
      break;

    case 'justify':
      newType = DEFAULT_BLOCK_TYPE;
      newData[TEXT_ALIGN_BLOCK_DATA_KEY] = 'justify';
      break;
    // Ordered List And Text Alignment

    case 'ol':
      newType = ListBlockTypes.ORDERED_LIST_ITEM;
      break;

    case 'left-ol':
      newType = ListBlockTypes.ORDERED_LIST_ITEM;
      newData[TEXT_ALIGN_BLOCK_DATA_KEY] = 'left';
      break;

    case 'center-ol':
      newType = ListBlockTypes.ORDERED_LIST_ITEM;
      newData[TEXT_ALIGN_BLOCK_DATA_KEY] = 'center';
      break;

    case 'right-ol':
      newType = ListBlockTypes.ORDERED_LIST_ITEM;
      newData[TEXT_ALIGN_BLOCK_DATA_KEY] = 'right';
      break;

    case 'justify-ol':
      newType = ListBlockTypes.ORDERED_LIST_ITEM;
      newData[TEXT_ALIGN_BLOCK_DATA_KEY] = 'justify';
      break;
    // Unordered List And Text Alignment

    case 'ul':
      newType = ListBlockTypes.UNORDERED_LIST_ITEM;
      break;

    case 'left-ul':
      newType = ListBlockTypes.UNORDERED_LIST_ITEM;
      newData[TEXT_ALIGN_BLOCK_DATA_KEY] = 'left';
      break;

    case 'center-ul':
      newType = ListBlockTypes.UNORDERED_LIST_ITEM;
      newData[TEXT_ALIGN_BLOCK_DATA_KEY] = 'center';
      break;

    case 'right-ul':
      newType = ListBlockTypes.UNORDERED_LIST_ITEM;
      newData[TEXT_ALIGN_BLOCK_DATA_KEY] = 'right';
      break;

    case 'justify-ul':
      newType = ListBlockTypes.UNORDERED_LIST_ITEM;
      newData[TEXT_ALIGN_BLOCK_DATA_KEY] = 'justify';
      break;
    // Keep current settings.

    default:
      break;
  }

  var inlineStyleRanges = [];

  if (block.inlineStyleRanges && block.inlineStyleRanges.length) {
    inlineStyleRanges = block.inlineStyleRanges.map(function (styleRange) {
      if (styleRange.style.startsWith('#')) {
        var rgb = hexToRgb(styleRange.style);
        return _objectSpread({}, styleRange, {
          style: "color-rgb(".concat(rgb.r, ",").concat(rgb.g, ",").concat(rgb.b, ")")
        });
      }

      return styleRange;
    });
  }

  return _objectSpread({}, block, {
    type: newType,
    inlineStyleRanges: inlineStyleRanges,
    data: _objectSpread({}, block.data, newData)
  });
}

// We intentionally do not import the constants for these from the codebase for integrity of the migration.
// If those constants were to change later, this migration could potentially be doing the wrong thing.
var LinkTypes = {
  WEB_ADDRESS: 'WEB_ADDRESS',
  EMAIL_ADDRESS: 'EMAIL_ADDRESS'
};
var LinkTargets = {
  CURRENT_TAB: '_self',
  NEW_TAB: '_blank'
};
/**
 * Version 1:
 * Migrating from nucleus-core rich text editor raw draftjs JSON object to one that is compatible with
 * the carina-rich-text-editor.
 */

function entityMapMigrations(entity) {
  // Migrate old links to new links.
  if (entity.type === 'LINK') {
    // In the case of copy pasting external links in the nucleus-core RTE, the data object does not get built
    // correctly and instead contains identical 'url' and 'href' properties.
    if (entity.data.hasOwnProperty('url')) {
      // Email Link
      if (entity.data.url.startsWith('mailto:')) {
        return _objectSpread({}, entity, {
          data: {
            url: entity.data.url,
            target: LinkTargets.NEW_TAB,
            type: LinkTypes.EMAIL_ADDRESS
          }
        });
      } // Web Link


      return _objectSpread({}, entity, {
        data: {
          url: entity.data.url,
          target: LinkTargets.NEW_TAB,
          type: LinkTypes.WEB_ADDRESS
        }
      });
    } // Email links.


    if (entity.data.linkType === 'Email') {
      var emailUrl = '';

      if (entity.data.data.emailAddress) {
        emailUrl = entity.data.data.emailAddress.startsWith('mailto:') ? entity.data.data.emailAddress : "mailto:".concat(entity.data.data.emailAddress);
      }

      return _objectSpread({}, entity, {
        data: {
          url: emailUrl,
          target: LinkTargets.NEW_TAB,
          type: LinkTypes.EMAIL_ADDRESS
        }
      });
    } // Web links.


    var webUrl = '';

    if (entity.data.data.url) {
      webUrl = entity.data.data.protocol ? "".concat(entity.data.data.protocol).concat(entity.data.data.url) : "https://".concat(entity.data.data.url);
    }

    return _objectSpread({}, entity, {
      data: {
        url: webUrl,
        target: LinkTargets.NEW_TAB,
        type: LinkTypes.WEB_ADDRESS
      }
    });
  } // No migration, just return the original entity.


  return entity;
}

var DATA_MODEL_VERSION = 1;
var DATA_MODEL_FORMAT = 'draftjs-nucleus';

/**
 * v1 migrations for the rich text data value object.
 * This initial migration is to migrate from the old nucleus-core rich text editor to the new data model.
 * The old model was just the content object, there is now a higher level with the format, version, and content
 * properties. These new fields let us appropriately type/version our rich text content.
 */

function v1(data) {
  return {
    format: DATA_MODEL_FORMAT,
    version: 1,
    content: {
      blocks: !data.blocks ? [] : data.blocks.map(blockMigrations),
      entityMap: !data.entityMap ? {} : mapValues(data.entityMap, entityMapMigrations)
    }
  };
}

/**
 * Migrations for the rich text data value object.
 * Version 0: the nucleus-core RichTextEditor's "editorState" JSON object
 * Version 1: the @cvent/carina-rich-text-editor RichTextEditor's initial backing JSON object
 */

function migrations(data) {
  // If there is no data, or the format is incompatible, return a data object with the correct format/version
  // and empty content. Possibly in the future have a way to migrate between different formats?
  if (!data || data.format && data.format !== DATA_MODEL_FORMAT) {
    return {
      format: DATA_MODEL_FORMAT,
      version: DATA_MODEL_VERSION,
      content: undefined
    };
  }

  var newData = _objectSpread({}, data); // Version 0 -> 1.


  if (!newData.version || newData.version < 1) {
    newData = v1(newData);
  }

  return newData;
}

export default migrations;
export { migrations, DATA_MODEL_VERSION, DATA_MODEL_FORMAT };
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@cvent/carina-rich-text-migrations/lib/es/index.js
// module id = ./node_modules/@cvent/carina-rich-text-migrations/lib/es/index.js
// module chunks = 0 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44